import { Typography } from '@mui/material'
import BackIconTextButton from 'components/atoms/button/BackIconTextButton'
import AboutPage from 'components/templates/navigationPageTemplates/AboutPage'
import { useTranslation, Trans } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { FEATURE_KEYS } from 'services/constants'
import { isAllowedFeature } from 'utils/permissionCheck'
import {
  ContainerLarge,
  ParentGridContainer
} from 'components/atoms/container/ResponsiveContainers'
import { ColStack } from 'components/atoms/container/InCardStack'
import SectionDivider from 'components/atoms/SectionDivider'
import { InTextAction, ContactMonark } from 'components/atoms/Text'
import { MONARK_PRIVACY_POLICY_URL } from 'utils/constants'

const Confidentiality = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const showBackButton = location.state?.showBackButton
  const getTextLabel = key =>
    t(
      `confidentiality.${isAllowedFeature(FEATURE_KEYS.FULL_LEADERSHIP_ASSESSMENT) ? 'fullAssessment' : 'basic'}.${key}`
    )
  return (
    <AboutPage customizedBodyWidth={true}>
      <ContainerLarge>
        <ParentGridContainer maxWidth={892}>
          <ColStack spacing={12}>
            {showBackButton ? <BackIconTextButton /> : null}
            <Typography variant='h1'>
              {t('confidentiality.confidentialityPrivacy')}
            </Typography>
            <Typography variant='h2'>
              {t('confidentiality.for360DegreeAssessments')}
            </Typography>
            <Typography variant='body1'>{getTextLabel('part1')}</Typography>
            <Typography variant='body1'>{getTextLabel('part2')}</Typography>
            <Typography variant='body1'>{getTextLabel('part3')}</Typography>
            {isAllowedFeature(FEATURE_KEYS.FULL_LEADERSHIP_ASSESSMENT) && (
              <>
                <Typography variant='body1'>{getTextLabel('part4')}</Typography>
                <Typography variant='body1'>{getTextLabel('part5')}</Typography>
              </>
            )}
            <SectionDivider />
            <Typography variant='h2'>
              {t('confidentiality.privacyPolicyForCalendar')}
            </Typography>
            <Typography variant='body1'>
              <Trans i18nKey={'confidentiality.personalDataNeverShared'} />
            </Typography>
            <Typography variant='body1'>
              <Trans i18nKey={'confidentiality.doNotUseAnyIdentifiableData'} />
            </Typography>
            <InTextAction
              i18nKey={'confidentiality.reviewingPrivacyPolicies'}
              actionProps={{
                href: MONARK_PRIVACY_POLICY_URL,
                target: '_blank'
              }}
            />
            <ContactMonark
              i18nKey={'confidentiality.additionalQuestions'}
              variant='body1'
              color='primary.main'
              fontStyle='normal'
            />
          </ColStack>
        </ParentGridContainer>
      </ContainerLarge>
    </AboutPage>
  )
}

export default Confidentiality
